import shop from "@/api/stocks";
// initial state
const state = {
  all: [],
  Stock: {},
  selectedStocks: []
};
// getters
const getters = {
  Stock: state => {
    return state.Stock;
  }
};

// actions
const actions = {
  async getAllStocks({ commit }) {
    const Stocks = await shop.getStocks();
    commit("getStocks", Stocks.data);
    return Stocks.data;
  },
  searchStock: async (context, Stock) => {
    let d = (await shop.searchStock(Stock)).data;
    context.commit("getStocks", d);
    return d;
  },
  getStock: async (context, id) => {
    let d = (await shop.getStock(id)).data;
    context.commit("getStock", d);
    return d;
  },
  postStock: async (context, Stock) => {
    const result = (await shop.postStock(Stock)).data;
    context.commit("postStock", result);
  },
  putStock: async (context, Stock) => {
    const result = (await shop.putStock(Stock)).data;
    context.commit("putStock", result);
  },
  deleteStock: async (context, Stock) => {
    const result = (await shop.deleteStock(Stock)).data;
    // eslint-disable-next-line no-console
    console.log(result);
    context.commit("deleteStock", Stock);
  },
  bulkUpdateStates: async (context, model) => {
 await shop.bulkUpdateStates(model);
    // eslint-disable-next-line no-console
    context.commit("bulkUpdateStates", model);
  }
};

// mutations
const mutations = {
  getStocks(state, Stocks) {
    state.all = Stocks;
  },
  setSelectedStocks(state, Stocks) {
    state.selectedStocks = Stocks;
  },
  getStock(state, Stock) {
    //state.Stock = Stock
    state.Stock = null;
    state.Stock = Object.assign({}, state.Stock, Stock);
  },
  postStock(state, Stock) {
    //state.Stock = Stock
    state.Stock = null;
    state.Stock = Object.assign({}, state.Stock, Stock);
  },
  putStock(state, Stock) {
    //state.Stock = Stock
    state.Stock = null;
    state.Stock = Object.assign({}, state.Stock, Stock);
  },
  deleteStock(state, Stock) {
    state.all.splice(state.all.indexOf(Stock), 1);
  },
  bulkUpdateStates(state, model) {
    // const data = model.selecteItems.map(({ id }) => id);
    state.all = Object.assign({}, state.all, model);

    // state.all.splice(state.all.indexOf(Stock), 1);
  },
  decrementStockInventory(state, { id }) {
    const Stock = state.all.find(Stock => Stock.id === id);
    Stock.inventory--;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
